;(function( window, document, $, undefined ) {
	'use strict';

	// Footer

	function footer() {

    // Form Footer Position
    function formPosition() {
      if( $('.footer-widgets-5').length > 0 ) {
        var positionWidgetContact = $('.footer-widgets-5').offset().left;
        var positionWidgetWrap = $('.footer-widgets .wrap').offset().left;
        $('.footer-widgets-6').css({
          left: positionWidgetContact - positionWidgetWrap,
          right: 'inherit'
        });
      }
    }

    // Widgets Group
    function widgetsGroup() {
      $('.footer-widgets-2, .footer-widgets-3, .footer-widgets-4, .footer-widgets-5').wrapAll('<div class="footer-widgets-group">');
    }

		// Globals
		return {
      formPosition : formPosition,
      widgetsGroup: widgetsGroup
		};

	}

	// Globals
	window.callsource = window.callsource || {};
  window.callsource.footer = footer();

})( window, document, jQuery );
